﻿/**
 * FetchItDashboard client components
 *
 * Primatech d.o.o.
 */

import Vue from 'vue';



export default app;